/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @flow
 */
import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * AdAccountContentFilterLevelsInheritance
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class AdAccountContentFilterLevelsInheritance extends AbstractCrudObject {
  static get Fields () {
    return Object.freeze({
      an_business_ids: 'an_business_ids',
      an_level: 'an_level',
      facebook_business_ids: 'facebook_business_ids',
      facebook_level: 'facebook_level',
    });
  }

}
